import * as React from 'react';

const SizeContext = React.createContext(undefined);
const SizeContextProvider = ({ children, size }) => (React.createElement(SizeContext.Consumer, null, (originSize) => React.createElement(SizeContext.Provider, { value: size || originSize }, children)));

export { SizeContextProvider, SizeContext as default };
//# sourceMappingURL=SizeContext.js.map
